import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { API_URL } from '../constants/api';

const UserContext = createContext(null);

export function UserProvider({ children, deviceId, initData }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [authLoading, setAuthLoading] = useState(true);

  // Update from initData when it loads
  useEffect(() => {
    if (initData?.loaded) {
      setIsAdmin(initData.isAdmin || false);
      setIsAuthenticated(initData.authenticated || false);
      setUserEmail(initData.userEmail || '');
      setAuthLoading(false);
    }
  }, [initData]);

  const logout = async () => {
    try {
      const response = await fetch(`${API_URL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include'
      });

      if (!response.ok) {
        console.warn('Logout request failed, clearing local state anyway');
      }

      setIsAuthenticated(false);
      setUserEmail('');
      console.log('Logged out');
    } catch (error) {
      console.error('Logout error:', error);
      setIsAuthenticated(false);
      setUserEmail('');
    }
  };

  // Refresh auth after login
  const refreshAuth = useCallback(async () => {
    if (initData?.refetch) {
      await initData.refetch();
    }
  }, [initData]);

  const value = {
    deviceId,
    isAdmin,
    setIsAdmin,
    isAuthenticated,
    setIsAuthenticated,
    userEmail,
    setUserEmail,
    authLoading,
    logout,
    refreshAuth,
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}
